import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/API/api.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.scss'
})
export class OrdersComponent implements OnInit {

  showSuccess: boolean = false;
  showError: boolean = false;
  successMsg = ''
  errorMsg = ''
  orders: any
  ordersCounter = 0

  constructor(private api: ApiService){}

  ngOnInit(): void {
    const token = localStorage.getItem('userToken')
    if(!token){
      this.showError = true
      this.errorMsg = 'برجاء تسجيل الدخول اولا'
      setTimeout(() => {
        this.showError = false
        this.errorMsg = ''
        history.back();
      }, 4000);
    }

    if(token){
      this.allOrders()
    }
  }

  allOrders(){
    this.api.allOrders().subscribe({
      next: (response) => {
        this.orders = response.data
        this.ordersCounter = this.orders.lenght
        console.log(this.orders)
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }

  cancelOrder(orderId: number) {
    if(orderId){
      this.api.cancelOrder(orderId).subscribe({
        next: (response) => {
          if(response.success == true){
            this.showSuccess = true
            this.successMsg = 'تم الغاء الطلب بنجاح'
            this.allOrders()
            setTimeout(() => {
              this.showSuccess = false
              this.successMsg = ''
            }, 3000);
          }else{
            this.showError = true
            this.errorMsg = 'لا يمكن إلغاء هذا الطلب، لقد انتهت فترة الإلغاء بالفعل'
            setTimeout(() => {
              this.showError = false
              this.errorMsg = ''
            }, 3000);
          }
          console.log(response)
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }
  }
  
  reorder(orderId: number) {
    // Implement your reorder logic here
    console.log('Reordering:', orderId);
    // You might want to call an API service to create a new order
    if(orderId){
      this.api.reorderOrder(orderId).subscribe({
        next: (response) => {
          console.log(response)
          if(response.success == true){
            this.showSuccess = true
            this.successMsg = 'لقد تم إرسال طلبك بنجاح، لديك 3 دقائق فقط للإلغاء'
            this.allOrders()
            setTimeout(() => {
              this.showSuccess = false
              this.successMsg = ''
            }, 3000);
          }
        }, error: (error: HttpErrorResponse) => {
          this.showError = true
          this.errorMsg = 'حدث خطأ, برجاء المحاولة لاحقا'
          setTimeout(() => {
            this.showError = false
            this.errorMsg = ''
          }, 3000);
        }
      })
    }
  }
  
  deleteOrder(orderId: number) {
    if(orderId){
      this.api.deleteOrder(orderId).subscribe({
        next: (response) => {
          console.log(response)
          if(response.success == true){
            this.showSuccess = true
            this.successMsg = 'تم حذف الطلب بنجاح'
            this.allOrders()
            setTimeout(() => {
              this.showSuccess = false
              this.successMsg = ''
            }, 3000);
          }else{
            this.showError = true
            this.errorMsg = 'لا يمكنك حذف الطلبات غير المسلمة'
            setTimeout(() => {
              this.showError = false
              this.errorMsg = ''
            }, 3000);
          }
        }, error: (error: HttpErrorResponse) => {
          this.showError = true
          this.errorMsg = 'حدث خطأ, برجاء المحاولة لاحقا'
          setTimeout(() => {
            this.showError = false
            this.errorMsg = ''
          }, 3000);
        }
      })
    }
  }

  defaultAvatar = './assets/img/logo.ico'; // Your default image path

  handleImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    // First try your local fallback
    imgElement.src = this.defaultAvatar;
    
    // If local fallback fails, use placeholder
    imgElement.onerror = () => {
      imgElement.src = 'https://via.placeholder.com/50';
    };
  }

  goBack(){
    window.location.href = '/'
  }
}
